import React, { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Gallery } from './components/Gallery';
import { GuideContents } from './components/GuideContents';
import { Bonuses } from './components/Bonuses';
import { TemplatePacks } from './components/TemplatePacks';
import { TemplatesSection } from './components/TemplatesSection';
import { Testimonials } from './components/Testimonials';
import { Carousel } from './components/Carousel';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    document.title = 'Deco Emprende | Falso Vitral Deco';
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2083053129755433');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2083053129755433&ev=PageView&noscript=1" />';
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      if (noscript.parentNode) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-deco-cream font-sans selection:bg-deco-brick selection:text-white" data-id="element-0" data-mp="35yngfn0fdzc">
      <TopBar data-id="element-1" data-mp="3udkoe0ich2ci" />
      <OfferBar data-id="element-2" data-mp="3ubzt28o7hfdl" />
      <main data-id="element-3" data-mp="3uc9o4ao3ycq5">
        <Hero data-id="element-4" data-mp="3uevpttobhy0g" />
        <Benefits data-id="element-5" data-mp="d4nx5l4r5s4i" />
        <Gallery data-id="element-6" data-mp="d57hf8hvkslp" />
        <GuideContents data-id="element-7" data-mp="d3mkxdc02zl7" />
        <Bonuses data-id="element-8" data-mp="d45vg8zbmlp7" />
        <TemplatePacks data-id="element-9" data-mp="d2l6qzzotwz9" />
        <TemplatesSection data-id="element-10" data-mp="85uk1ttdo34v" />
        <Testimonials data-id="element-11" data-mp="86mev2f5hwu3" />
        <Carousel data-id="element-12" data-mp="864d5q9pyqes" />
        <PurchaseSection data-id="element-13" data-mp="83i6rtykegy5" />
        <FAQ data-id="element-14" data-mp="3gl4qtf87pwiz" />
        <FinalCTA data-id="element-15" data-mp="3gklau424hi7l" />
      </main>
      <Footer data-id="element-16" data-mp="3glwapssg65tf" />
      <SocialProofPopup data-id="element-17" data-mp="3gja6o34rm8fy" />
    </div>;
}